import * as React from 'react';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import { Icon } from '../Icon/Icon';
import { Bem, addClass } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import './HeaderBrand.css';
const bem = Bem.create('vai-header-brand');
export function HeaderBrand({ visible, animated = true, className, htmlId, dataTa, ...rest }) {
    const id = useId(htmlId, ['header branding']);
    const classes = addClass(bem.block(visible ? 'visible' : 'hidden', animated && 'animated'), className);
    return (React.createElement("div", Object.assign({ id: id.toString(), className: classes, "data-ta": dataTa }, rest),
        React.createElement("div", { className: bem.element('container')(visible ? 'visible' : 'hidden') },
            React.createElement(Icon, { name: VaiIcon.VaisalaLogoLarge, className: bem.element('content')() }))));
}
//# sourceMappingURL=HeaderBrand.js.map